
export default {
  title: 'Boostez votre activité avec un site dernier cri !',
  cta: 'CONTACTEZ NOUS',
  subtitle: [
    'Vôtre site internet commence à dater ?',
    'Vôtre entreprise ne possède pas de site internet ?',
    'N\'attendez plus ! Opérez vôtre transformation Digital dès maintenant !',
    'Qui suis-je ?',
    'Contactez moi !'
  ],
  text: [
    'Un vieux site internet n\'est',
    'pour transmettre vôtre message. Il vous',
    'et ne vous rapporte rien en retour. Pire, il renvoie une',
    'de vôtre activité et peut même faire',
    'potentiel (surtout les jeunes) !',
    'Nous vivons à',
    ', et même si vôtre activité c\'est toujours bien portée sans site internet, cela risque d\'être de moins en moins le cas dans',
    '. Quand bien même vous avez la chance d\'être dans un secteur à l\'abri de la',
    ', posséder un site internet peut tout de même vous',
    'Un site internet moderne c\'est avant tout :',
    'Enchanté je m’appelle Pierre-Louis Despaigne ! Je suis un développeur web freelance.',
    'Mon travaille est de vous conseiller et de vous accompagner tout au long de la réalisation de vôtre site internet. Vous exprimez vos besoins et vos envie, et je m\'occupe de tout !',
    'A chaque étape nous restons en contact pour garantir que la réalisation avance dans la bonne direction.',
    'Pour savoir si je peut vous être utile, le mieux c\'est d\'en discuter !'
  ],
  bold: [
    'pas efficace',
    'coute de l\'argent',
    'image négative',
    'fuir des clients',
    'l\'époque du tout Digital',
    'le futur',
    'Digitalisation',
    'apporter beaucoup !',
    'Contactez moi directement, ou laissez votre mail pour que je vous contact'
  ],
  list: [
    'une bonne façon de se démarquer de vos concurrent',
    'une marque de crédibilité',
    'la vitrine de votre entreprise',
    'une source d\'information toujours disponible',
    'une façon de mieux connaitre ses clients',
    'un moyen d\'attirer de nouveaux clients',
    'un investissement qui peut parfois rapporter gros',
    'écriture du contenu',
    'design des pages',
    'développement du site',
    'déploiement sur internet',
    'par mail (pour les petites questions)',
    'par téléphone',
    'par webcam',
    'ou même physiquement si vous êtes basé à Lyon'
  ],
  lorem: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vulputate nisl risus, a varius sapien blandit in. Mauris facilisis fringilla malesuada. Pellentesque maximus nulla at metus tincidunt bibendum. Nulla eleifend lacus ut felis interdum, sed imperdiet urna aliquet. Vestibulum lorem libero, tempor ut diam nec, cursus aliquam felis. Sed id volutpat purus. Duis ut eros tincidunt, ornare quam at, faucibus arcu. Nam turpis purus, pretium sed ullamcorper nec, scelerisque ut odio. Aliquam at nisl vitae orci auctor luctus vel hendrerit lectus. Pellentesque tempus purus in ligula pulvinar, at blandit nunc sodales. Donec aliquam, nibh nec auctor sagittis, massa mauris maximus ante, in ultrices eros dolor eget sem. Quisque nec mattis nunc, sit amet dapibus ante. Duis ac neque efficitur, varius odio id, malesuada nisl. Integer tincidunt lectus eget ipsum fermentum, ut placerat felis accumsan. Duis id lacus tincidunt, fermentum elit id, dictum felis. '
}



// WEBPACK FOOTER //
// ./src/content/fr.js